import React from 'react';
import Hero from '../components/Hero';
import ProductCapabilities from '../components/ProductCapabilities';
import LegacySystemTax from '../components/LegacySystemTax';
import CentralizedTradingHub from '../components/CentralizedTradingHub';
import EveryProtocolOneSystem from '../components/EveryProtocolOneSystem';
import EcosystemCompatibility from '../components/EcosystemCompatibility';
import ZeroRiskImplementation from '../components/ZeroRiskImplementation';
import WhyUs from '../components/WhyUs';
// import RecentPosts from '../components/RecentPosts';
import CallToAction from '../components/CallToAction';
import FAQ from '../components/FAQ';
import ContactUs from '../components/ContactUs';

const Home = () => {
    return (
        <>
            <Hero />
            <ProductCapabilities />
            <LegacySystemTax />
            <EveryProtocolOneSystem />
            <CentralizedTradingHub />
            <EcosystemCompatibility />
            <ZeroRiskImplementation />
            <WhyUs />
            {/* <RecentPosts /> */}
            <CallToAction />
            <FAQ />
            <ContactUs />
        </>
    );
};

export default Home;
